/*
 * @Author: your name
 * @Date: 2020-12-16 17:26:30
 * @LastEditTime: 2023-11-28 14:17:08
 * @LastEditors: youqifa youqifa@yxj.org.cn
 * @Description: In User Settings Edit
 * @FilePath: \yszFormula\src\components\formulaComponent\formulaInput.js
 */
// 引入组件
import formulaInput from './formulaInput.vue'
import formulaScore from './formulaScore.vue'
import formulaDescScore from './formulaDescScore.vue'
import ftitle from './ftitle.vue'
import clinicaluse from './clinicaluse.vue'
import references from './references.vue'
import reference from './reference.vue'
import pubmed from './pubmed.vue'
import citation from './citation.vue'
import subtitle from './subtitle.vue'
import formula from './formula.vue'
import formatted from './formatted.vue'
import credits from './credits.vue'
import formulaLabelSelect from './formulaLabelSelect.vue'
import detailReferences from './detailReferences.vue'
import commonInfo from './commonInfo.vue'

import units from './units.vue'
import unit from './unit.vue'
import clinicalSignificances from './clinicalSignificances.vue'
import clinicalSignificance from './clinicalSignificance.vue'
import clinicaluseValue from './clinicaluseValue.vue'

const context = require.context('@/pages/formulasInfo', true, /\.vue$/)
console.log(context, '123456778')

// 自定义组件对象
const FormulaCommonComponent = {
        // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数
        install: function(Vue) {
            // Vue.component() 与正常的全局注册组件用法相同，可以理解为通过 install 和 Vue.use()函数注册了全局组件
            Vue.component('FormulaInput', formulaInput)
            Vue.component('FormulaScore', formulaScore)
            Vue.component('FormulaDescScore', formulaDescScore)

            Vue.component('ftitle', ftitle)
            Vue.component('clinicaluse', clinicaluse)
            Vue.component('FormulaDescScore', formulaDescScore)
            Vue.component('references', references)
            Vue.component('reference', reference)
            Vue.component('pubmed', pubmed)
            Vue.component('citation', citation)
            Vue.component('subtitle', subtitle)
            Vue.component('formula', formula)
            Vue.component('formatted', formatted)
            Vue.component('credits', credits)
            Vue.component('units', units)
            Vue.component('unit', unit)
            Vue.component('formulaLabelSelect', formulaLabelSelect)
            Vue.component('detailReferences', detailReferences)
            Vue.component('clinicalSignificances', clinicalSignificances)
            Vue.component('clinicalSignificance', clinicalSignificance)
            Vue.component('clinicaluseValue', clinicaluseValue)
            Vue.component('commonInfo', commonInfo)
            let componentsList=[]
            context.keys().forEach((key) => {
                const component = context(key).default
                    // console.log(component.name);
                let name = component.name.replace(/_/g, '')
                Vue.component(name, component)
                componentsList.push(component)
            })
            componentsList&&componentsList.length>0&&localStorage.setItem('componentsList',JSON.stringify(componentsList))
        }
    }
    // 导出
export default FormulaCommonComponent



// WEBPACK FOOTER //
// ./src/components/formulaComponent/formulaInput.js